import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { ModalName } from "src/app/enums/modal-name";
import { IContact } from "src/app/models/contact/contact";
import { IContactsSearchParams } from "src/app/models/contact/contacts-search-params";
import { ContactService } from "src/app/services/contact.service";
import { ModalService } from "src/app/services/modal.service";

@Component({
  selector: "app-select-contact-modal",
  templateUrl: "./select-contact-modal.component.html",
  styleUrls: ["./select-contact-modal.component.scss"],
})
export class SelectContactModalComponent implements OnInit {
  @Output() close  = new EventEmitter<void>();
  @Output() select = new EventEmitter<IContact>();

  isContactsExist = false;

  contacts: IContact[] = [];
  contactsSearchParams: IContactsSearchParams = {
    pageNumber:   "1",
    pageSize:     "10",
    searchString: ""
  };

  constructor(
    private readonly _modalService: ModalService,
    private readonly _contactService: ContactService
  ) {}

  get isOpen() {
    return this._modalService.openedModalName === ModalName.SelectContact;
  }

  onClose() {
    this._modalService.closeModal();
    this.close.emit();
  }

  getContacts() {
    let search = this.contactsSearchParams.searchString;

    this._contactService.getAll(this.contactsSearchParams).subscribe(contacts => {
      this.isContactsExist = contacts.records.length > 0 || search != "";
      this.contacts        = contacts.records;
    });
  }

  onSelect(contact: IContact) {
    this._modalService.closeModal();
    this.select.emit(contact);
  }

  ngOnInit() {
    this.getContacts();
  }
}
